import { useNavigate, useParams } from "react-router-dom";
import { PolicyCancellationForm } from "../../Cancellation/PolicyCancellationForm";
import { useBusinessPremium } from "../../../../../../hooks/useCustomerPremium";
import { MODULE_IDS } from "../../../../../../constants/enums";
import {
  useBusinessCustomerBasicDetails,
  useBusinessPolicyAdmin,
} from "../../../../../../hooks";
import { PageContainer } from "../../../../../../components/container/PageContainer";

export const BusinessCancellation: React.FC<{ isDuplicate?: boolean }> = (
  props
) => {
  const { customerId, customerPolicyId, serialNumber } = useParams() as {
    customerId?: number;
    customerPolicyId?: number;
    serialNumber?: number;
  };

  const { isDuplicate } = props;

  const customerBasicDetail = useBusinessCustomerBasicDetails(customerPolicyId);

  const premium = useBusinessPremium(customerPolicyId);
  const agencyBill = premium.data.agency_bill_or_direct_bill;
  const { policyAdmin, insurer, branch } =
    useBusinessPolicyAdmin(customerPolicyId);
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(
      `/business-policy/${customerId}/policy-forms-tab/${customerPolicyId}?tab=4`
    );
  };
  return (
     <PageContainer
        title={serialNumber ? "Edit business cancellation" : "Create business cancellation"}
        description="This is the consent form page"
      >
      {customerPolicyId && customerId && (
        <PolicyCancellationForm
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          incrementalNumber={serialNumber}
          isDuplicate={isDuplicate}
          handleNavigate={handleNavigate}
          agencyBill={agencyBill}
          policy="business"
          lineOfBusiness={customerBasicDetail.data.line_of_business}
          subType={customerBasicDetail.data.sub_type}
          customerCode={customerBasicDetail.data.customer_code}
          customerName={customerBasicDetail.data.customer_name}
          policyNumber={customerBasicDetail.data.policy_number || customerBasicDetail.data.binder_number}
          branch={branch.branch_code}
          broker_code={policyAdmin.data.broker_code}
          producer_one_code={policyAdmin.data.producer_1_code}
          producer_one_id={policyAdmin.data.producer_1}
          csr={policyAdmin.data.csr_code}
          insurer={`${insurer.name}(${insurer.insurer_code})`}
          securityType={`${MODULE_IDS.BUSINESS_POLICY}`}
        />
      )}
    </PageContainer>
  );
};
